import { CreditCardNetwork } from '@wix/cashier-common/dist/src/enums/payments/CreditCardNetwork';
import React from 'react';
import { DH } from '../../../../utils/DataHook';
import * as s from './styles.scss';

export const CreditCardNetworkIcon: React.FunctionComponent<{
  cardNetwork: CreditCardNetwork;
}> = (props) => (
  <div data-hook={DH.MethodsList.Item.Icon} className={s.creditCardNetwork}>
    <img
      className={s.creditCardNetworkIcon}
      alt={props.cardNetwork}
      src={`https://static.parastorage.com/services/wallet/1.51.43/assets/images/cardNetwork/${props.cardNetwork}.svg`}
    />
  </div>
);
CreditCardNetworkIcon.displayName = 'CreditCardNetworkIcon';
